import React, { FunctionComponent, useEffect } from 'react';
import { Models, Api, States } from '@core/types';
import { connect } from 'react-redux';
import { usePassportContext } from '@tti/passport';
import { projectActionCreators } from '@redux/projects';
import { Accordion } from '@components/shared';
interface IProps {
  project: Models.Project;
  projectPDFs: States.IProjectState['currentProjectPDFs'];
  fetchProjectPdfs: (params: Api.IFetchProjectPdfsRequest) => void;
}

const ProjectHeader: FunctionComponent<IProps> = ({ project, projectPDFs, fetchProjectPdfs }) => {
  const { passportContext } = usePassportContext();

  useEffect(() => {
    if (passportContext.bearerToken && project.projectGUID) {
      fetchProjectPdfs({
        bearerToken: passportContext.bearerToken,
        projectGUID: project.projectGUID,
      });
    }
  }, [passportContext.bearerToken, project.projectGUID, fetchProjectPdfs]);

  const getOrderNumber = (pdf: Models.ProjectPDF) => {
    return pdf.orderNumber ? (
      <>
        <strong>Order Number:</strong> {pdf.orderNumber}
      </>
    ) : (
      <strong>Download</strong>
    );
  };

  const getCompanyName = (pdf: Models.ProjectPDF) => {
    return pdf.orderCompanyName || 'N/A';
  };

  const getTemplateName = (pdf: Models.ProjectPDF) => {
    return pdf.templateName || 'Unknown Template';
  };

  const getPDFHistoryCount = () => {
    return projectPDFs.pdfs.length;
  };

  return (
    <div className="project-header">
      <div className="project-header__title">
        <h2 className="project-header__name">{project.projectName}</h2>
      </div>

      <div className="project-header__history">
        <Accordion title={`Output History (${getPDFHistoryCount()})`} isOpenByDefault={false} className="project-header__accordion">
          {projectPDFs.isLoading ? (
            <div className="project-header__loading">Loading Output History...</div>
          ) : projectPDFs.pdfs.length === 0 ? (
            <div className="project-header__empty">No PDFs generated yet for this project.</div>
          ) : (
            <ul className="project-header__pdf-list">
              {projectPDFs.pdfs.map((pdf, index) => (
                <li key={`${pdf.projectPDFID}-${index}`} className="project-header__pdf-item">
                  <div className="project-header__pdf-details">
                    {getOrderNumber(pdf)} | <strong>Company:</strong> {getCompanyName(pdf)} | <strong>Template:</strong>{' '}
                    <span dangerouslySetInnerHTML={{ __html: getTemplateName(pdf) }} /> | <strong>Created:</strong> {pdf.createdAtISO}
                  </div>
                  {pdf.pdfUrl && (
                    <div className="project-header__pdf-link">
                      <a href={pdf.pdfUrl} target="_blank" rel="noopener noreferrer" className="btn project-header__pdf-download">
                        View PDF
                      </a>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          )}
        </Accordion>
      </div>
    </div>
  );
};

const mapStateToProps = (state: States.IRootState) => ({
  projectPDFs: state.project.currentProjectPDFs,
});

const mapDispatchToProps = {
  fetchProjectPdfs: (params: Api.IFetchProjectPdfsRequest) => projectActionCreators.fetchProjectPdfs(params),
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectHeader);
